var UserInterface = {
    email:String,
    password: String,
}
export default UserInterface;